import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Input, Confirm } from 'semantic-ui-react';
import * as _ from 'lodash';
import { GLOBAL_APPROVAL_STATUS } from '../../../../../HelperMethods/enums';
import ApprovalActionPopup from './ApprovalActionPopup';
import AttributeComponent from './AttributeComponent';
import Joyn2Button from '../../../../common/Joyn2Button';
import PortalComponent from '../../../../common/PortalComponent';
import { updateApprovalMatrixInfoOfATask } from '../../redux/actions';
import MatrixInfoComponent from './MatrixInfoComponent';

const globalApprovalStatusDict = _.keyBy(Object.values(GLOBAL_APPROVAL_STATUS), 'key', {});

const showResubmitButton = ({ loggedInUser, task, formik }) => {
  let showButton = false;
  const approvalInfo = _.get(formik, 'values.approval_matrixInfo', []) || [];
  for (const info of approvalInfo) {
    const foundReq = (info.approvers || []).some(
      (approver) => approver.approvalStatus === GLOBAL_APPROVAL_STATUS.NEED_MORE_INFO.key
    );
    if (foundReq) {
      showButton = true;
      break;
    }
  }
  if ((task.requestorIds || []).includes(loggedInUser) && showButton) {
    return true;
  }
  return false;
};

const ApprovalRequirementComponent = ({ formik, ...props }) => {
  const { task: { approvalStatus: globalApprovalStatus } = {} } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [dataForPopup, setDataForPopup] = useState({});
  const [confirmModal, handleConfirmModal] = useState({
    content: '',
    header: '',
    onCancel: () => {},
    onConfirm: () => {},
    open: false,
  });
  const [approvalStatusGlobal, setApprovalStatus] = useState(globalApprovalStatus);

  const handleToggle = useCallback(() => {
    setOpen((prevState) => !prevState);
  }, []);

  const handleApprovalStatus = useCallback(
    (status) => {
      setApprovalStatus(status);
    },
    [setApprovalStatus]
  );

  const handleAction = useCallback(
    ({ data, approverIndex, matrixIndex, statusForApprovalLimit }) => {
      handleToggle();
      setDataForPopup({ data, approverIndex, matrixIndex, statusForApprovalLimit });
    },
    [handleToggle]
  );

  const handleReSubmitButtonClick = () => {
    handleConfirmModal({
      open: true,
      header: 'Re-Submit',
      content: 'Do you want to Resubmit for Approval?',
      onCancel: () => {
        handleConfirmModal({ ...confirmModal, open: false });
      },
      onConfirm: async () => {
        try {
          handleConfirmModal({ ...confirmModal, open: false });
          const updatedTask = await dispatch(
            updateApprovalMatrixInfoOfATask({ taskId: props.task.id, resubmitForApproval: true })
          );
          formik.setFieldValue('approval_matrixInfo', updatedTask.approvalInfo, false);
          setApprovalStatus(updatedTask.approvalStatus);
        } catch (e) {
          console.error(e);
        }
      },
    });
  };

  return (
    <>
      <PortalComponent id="portal-button">
        {showResubmitButton({ task: props.task, loggedInUser: props.loggedInUser.id, formik }) && (
          <Joyn2Button
            margin="0 0 0 24px"
            size="large"
            label="Re-Submit for Approval"
            onClick={handleReSubmitButtonClick}
          />
        )}
      </PortalComponent>
      <div style={{ marginBottom: '12px' }}>
        <div>
          <label>Approval Status</label>
        </div>
        <div style={{ padding: '10px 0' }}>
          <Input
            disabled
            value={_.get(
              globalApprovalStatusDict,
              `[${approvalStatusGlobal}].label`,
              GLOBAL_APPROVAL_STATUS.PENDING_APPROVAL.label
            )}
          />
        </div>
      </div>
      <AttributeComponent matrixList={_.get(formik, 'values.approval_matrixInfo', [])} task={props.task} />
      <MatrixInfoComponent formik={formik} handleAction={handleAction} loggedInUser={props.loggedInUser} />
      {open && (
        <ApprovalActionPopup
          open={open}
          handleToggle={handleToggle}
          dataForPopup={dataForPopup}
          formik={formik}
          task={props.task}
          handleApprovalStatus={handleApprovalStatus}
        />
      )}

      {confirmModal.open && <Confirm size="mini" {...confirmModal} />}
    </>
  );
};

export default ApprovalRequirementComponent;
